import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconSquareBehindSquare6"><Path fillRule="evenodd" clipRule="evenodd" d="M7 3.75C7 3.33579 7.33579 3 7.75 3H20.25C20.6642 3 21 3.33579 21 3.75V16.26C21 16.6742 20.6642 17.01 20.25 17.01H17V20.25C17 20.6642 16.6642 21 16.25 21H3.75C3.33579 21 3 20.6642 3 20.25V7.75C3 7.33579 3.33579 7 3.75 7H7V3.75ZM17 15.51V7.75C17 7.33579 16.6642 7 16.25 7H8.5V4.5H19.5V15.51H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare6;
